import React from 'react';
import { Outlet } from 'react-router-dom';
import { GuestOnly } from '../guards/Guards';

/**
 * Auth plate: no header, no sidebar. Only login and forgot-password pages.
 */
export default function AuthLayout() {
  return (
    <GuestOnly>
      <div className="auth-plate">
        <Outlet />
      </div>
    </GuestOnly>
  );
}
